// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__2IByV","footer_version":"style_footer_version__I8-9d"};